import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ContactUsComponent } from '@finders/finder';

@Component({
  selector: 'finders-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  public menuOpen = false;

  constructor(
    private dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private router: Router
  ) {
    const iconRoot = 'assets/images/svgs';
    const icons = [
      {
        label: 'caret',
        path: `${iconRoot}/caret.svg`
      },
      {
        label: 'download',
        path: `${iconRoot}/download-icon.svg`
      },
      {
        label: 'pharmacy',
        path: `${iconRoot}/pharmacy-icon.svg`
      },
      {
        label: 'search',
        path: `${iconRoot}/search-icon.svg`
      },
      {
        label: 'pin',
        path: `${iconRoot}/search-pin.svg`
      },
      {
        label: 'treatment',
        path: `${iconRoot}/treatment-icon.svg`
      }
    ];

    for (const icon of icons) {
      this.matIconRegistry.addSvgIcon(
        icon.label,
        this.domSanitizer.bypassSecurityTrustResourceUrl(icon.path)
      );
    }

    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(() => {
        this.menuOpen = false;
      });
  }

  public openContactDialog() {
    this.menuOpen = false;
    this.dialog.open(ContactUsComponent, { maxWidth: '420px' });
  }

  public toggleMobileMenu() {
    this.menuOpen = !this.menuOpen;
  }
}
